import { usePostHog } from 'posthog-js/react';
import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { HeaderSection } from '@/sections/HeaderSection';
import './styles.scss';

const postHogEventName = 'pw_landing_page_redirect';

type Response = {
  [key: string]: string;
};

const fetchRedirectsConfig = async (): Promise<Response> => {
  const response = await fetch('/redirects-config.json', {
    cache: 'no-cache',
  });
  const json = await response.json();
  return json;
};

export const RedirectPage = () => {
  const { id } = useParams<{ id: string }>();
  const postHog = usePostHog();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchAndRedirect = async () => {
      if (!id) {
        console.error('No QR ID provided');
        return;
      }

      try {
        const mappings = await fetchRedirectsConfig();
        const normalizedId = id.toLowerCase().trim();
        const redirectUrl = mappings[normalizedId];

        if (redirectUrl) {
          if (postHog) {
            await postHog.capture(postHogEventName, { qr: id, redirectUrl });
          }

          if (redirectUrl.startsWith('/')) {
            navigate(redirectUrl);
          } else {
            window.location.href = redirectUrl;
          }
        } else {
          console.error(`No mapping found for QR ID: ${id}`);
        }
      } catch (err) {
        console.error('Error in QR redirect:', err);
      }
    };

    fetchAndRedirect();
  }, [postHog, id, navigate]);

  return (
    <div className='redirect-page'>
      <HeaderSection onContactClick={() => {}} withButton={false} />
      <div className='container content'>
        <h1 className='loading'>Redirecting</h1>
      </div>
    </div>
  );
};
